import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from "moment";
import Tooltip from '@material-ui/core/Tooltip';
import AlertModal from 'web/components/AlertModal';
import MultiSelectCheckBox from "web/components/form-elements/MultiSelectCheckBox";
import { deleteNeedRecurrence } from 'redux/actions/postLoad';
import { deleteInvRecurrence } from 'redux/actions/postInventory';
import OkCancelAlertModal from "web/components/OkCancelAlertModal";
import { getPostInitialValues, VALIDATION_SCHEMA, } from 'web/components/utils/deleteRecurrenceModalUtils';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components'
import styles from './deleteRecurrence.module.scss';
import { Container, Body, ActionBtn, Location, InfoTitleText } from './deleteRecurrenceStyled.js'
import { stateConvert } from '../utils/stateAbbreviation';
import NumberInput from '../form-elements/NumberInput';
import { fetchLanguageContentNew } from 'redux/actions/language';
import YesNoModal from '../YesNoModal';
import information from "web/assets/images/informationIcon.png";
import Edit from "web/assets/images/edit-icon-1.png";

export default ({ isOpen, toggle, title, callBackFun, items, postType, actionType }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  let token = localStorage.getItem("token");

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);

  const [okCancelModal, setOkCancelModal] = useState(false);
  const [okCancelModalContent, setOkCancelModalContent] = useState("");
  const toggleOkCancelModal = () => setOkCancelModal(!okCancelModal);

  const [multiSelectVal, setMultiSelectVal] = useState([]);
  const [futureRecDateList, setFutureRecDateList] = useState([])

  const currentLanguage = useSelector(state => state.language.currentLanguage);
  const languageContentNew = useSelector(state => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();
  const [pageLanguageInventoryContents, setPageLanguageInventoryContents] = useState();
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [yesNoModalType, setYesNoModalType] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
  const [loadSuccessState, setLoadSuccessState] = useState(false);

  //state to manage edit click
  const [isQtyEditable, setIsQtyEditable] = useState(false);
  const [isDesiredPriceEditable, setIsDesiredPriceEditable] = useState(false);
  const [isMinPriceEditable, setIsMinPriceEditable] = useState(false);
  const [isDeliveryPriceEditable, setIsDeliveryPriceEditable] = useState(false);
  const [isCpuPriceEditable, setIsCpuPriceEditable] = useState(false);

  useEffect(() => {
    let dateListTemp = items?.postRecurrence?.recurrenceDates?.map(data => ({ label: moment(data).format('MM/DD/YYYY'), value: data }))
    setFutureRecDateList(dateListTemp ? dateListTemp : [])
  }, [items])

  useEffect(() => {
    if (languageContentNew?.Buy_Arrow_PostLoad_Page) setPageLanguageContents(languageContentNew.Buy_Arrow_PostLoad_Page);
    if (languageContentNew?.Sell_Arrow_PostInventory_Page) setPageLanguageInventoryContents(languageContentNew.Sell_Arrow_PostInventory_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const submitHandler = async (props, flag) => {
    let dataList = multiSelectVal.map((item) => item.value);
    let data = {
      authId: localStorage.getItem('authId'),
      reccId: items?.id,
      dateList: dataList,
    };

    data.quantity = props?.values?.editRecuurenceQty || null

    if (postType === 'Need') {
      let targetPrice = props?.values?.desiredPrice
      if (props?.values?.desiredPrice.toString().charAt(0) === "$") {
        targetPrice = props?.values?.desiredPrice.replace('$', '')
      }
      if (items?.displayCostToMarket && (targetPrice === 0 || targetPrice === "0.00")) {
        setModalContent("Target price is a mandatory field.");
        setModalLink("");
        toggleModal();
        return;
      }

      data.targetPrice = (targetPrice && targetPrice !== '') ? parseFloat(targetPrice) : null;
    }

    if (postType === "Inventory") {
      let minDeliveredPrice = props?.values?.basePrice
      if (props?.values?.basePrice.toString().charAt(0) === "$") {
        minDeliveredPrice = props?.values?.basePrice.replace('$', '')
      }

      let buyNowDeliveredPrice = props?.values?.buyNowDeliveredPrice
      if (props?.values?.buyNowDeliveredPrice.toString().charAt(0) === "$") {
        buyNowDeliveredPrice = props?.values?.buyNowDeliveredPrice.replace('$', '')
      }

      let cpuPrice = props?.values?.cpuPrice
      if (props?.values?.cpuPrice.toString().charAt(0) === "$") {
        cpuPrice = props?.values?.cpuPrice.replace('$', '')
      }


      if (!((items?.shippingMode === "DELIVERY" &&
        (buyNowDeliveredPrice === 0 || minDeliveredPrice < buyNowDeliveredPrice) &&
        (cpuPrice === 0 || minDeliveredPrice < cpuPrice)) ||
        (items?.shippingMode === "PICKUP" && (cpuPrice === 0 || minDeliveredPrice < cpuPrice)) || flag)) {
        setYesNoModalType("inventory")
        setYesNoModalContent("The buy now price(s) are less than the target price. Do you wish to continue?");
        yesNoToggleModal();
        return;
      }

      if (items?.acceptanceMethod === "AUTOMATIC" && !minDeliveredPrice ||
        items?.acceptanceMethod === "MANUAL" && props?.values?.displayCostToMarket && !minDeliveredPrice) {
        setModalContent("Minimum delivered price is required.");
        setModalLink("");
        toggleModal();
        return;
      }

      data.minDeliveredPrice = (minDeliveredPrice && minDeliveredPrice !== '') ? parseFloat(minDeliveredPrice) : null;
      data.buyNowDeliveredPrice = (buyNowDeliveredPrice && buyNowDeliveredPrice !== '') ? parseFloat(buyNowDeliveredPrice) : null;
      data.buyNowPickupPrice = (cpuPrice && cpuPrice !== '') ? parseFloat(cpuPrice) : null;
    }

    let response;
    if (postType === 'Need') response = await dispatch(deleteNeedRecurrence(data, token));
    else if (postType === 'Inventory') response = await dispatch(deleteInvRecurrence(data, token));

    if (response.success) {
      setLoadSuccessState(true);
      setModalContent('Recurrence posts updated successfully.');
      setModalLink('');
      toggleModal();
    } else {
      setLoadSuccessState(false);
      if (response?.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }


  const recurrenceTag = (items) => {
    let dayOfWeekVal = "";
    if (items?.pattern?.dayOfWeek) {
      if (items?.pattern.dayOfWeek === "MONDAY") dayOfWeekVal = "M";
      if (items?.pattern.dayOfWeek === "TUESDAY") dayOfWeekVal = " T";
      if (items?.pattern.dayOfWeek === "WEDNESDAY") dayOfWeekVal = " W";
      if (items?.pattern.dayOfWeek === "THURSDAY") dayOfWeekVal = " Th";
      if (items?.pattern.dayOfWeek === "FRIDAY") dayOfWeekVal = " F";
      if (items?.pattern.dayOfWeek === "SATURDAY") dayOfWeekVal = " Sat";
      if (items?.pattern.dayOfWeek === "SUNDAY") dayOfWeekVal = " Sun";
    }
    let daysOfWeek = [];
    if (items?.pattern && (items?.pattern.type === "WEEKLY" || items?.pattern.type === "RELATIVEMONTHLY" || items?.pattern.type === "MONTHLY")) {
      for (let i = 0; i < items?.pattern.daysOfWeek.length; i++) {
        if (items?.pattern.daysOfWeek[i] === "MONDAY") daysOfWeek.push("M")
        if (items?.pattern.daysOfWeek[i] === "TUESDAY") daysOfWeek.push(" T")
        if (items?.pattern.daysOfWeek[i] === "WEDNESDAY") daysOfWeek.push(" W")
        if (items?.pattern.daysOfWeek[i] === "THURSDAY") daysOfWeek.push(" Th")
        if (items?.pattern.daysOfWeek[i] === "FRIDAY") daysOfWeek.push(" F")
        if (items?.pattern.daysOfWeek[i] === "SATURDAY") daysOfWeek.push(" Sat")
        if (items?.pattern.daysOfWeek[i] === "SUNDAY") daysOfWeek.push(" Sun")
      }
    }

    if (items?.pattern) {
      return (
        <TimeSection>
          <>
            <div className="flow-column">
              {items?.pattern.type === "DAILY" && (
                <span>
                  Daily,&nbsp;
                  <>
                    {"Starting  " + moment(items?.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items?.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
              {items?.pattern.type === "WEEKLY" && (
                <span>
                  Weekly,&nbsp;Every {daysOfWeek.join(",")},&nbsp;
                  <>
                    {"Starting  " + moment(items?.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items?.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
              {items?.pattern.type === "MONTHLY" && (
                <span>
                  Monthly,&nbsp;
                  {daysOfWeek.length !== 0 && <>Every {daysOfWeek.join(",")}</>}
                  &nbsp;
                  <>
                    {"Starting  " + moment(items?.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items?.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
              {items?.pattern.type === "RELATIVEMONTHLY" && (
                <span>
                  Monthly,&nbsp;
                  {items?.pattern.dayOfWeek && (<>Every {dayOfWeekVal}</>)}
                  &nbsp;
                  <>
                    {"Starting  " + moment(items?.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items?.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
            </div>
          </>
        </TimeSection>
      );
    }
  };

  const capitalizeFirstLetter = (input) => {
    if (input) return input[0].toUpperCase() + input.slice(1).toLowerCase();
  }

  const capitalize = (s) => {
    if (typeof s !== 'string')
      return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  const palletDetailsString = (items) => {
    let palletDetailsString
    if (items?.palletDetails?.material) palletDetailsString = capitalize(items?.palletDetails?.material.toLowerCase())
    if (items?.palletDetails?.condition) palletDetailsString = capitalize(palletDetailsString.toLowerCase()) + ', ' + (items?.palletDetails?.condition[0] === 'Recycled' ? 'Used' : capitalize(items?.palletDetails?.condition[0].toLowerCase()))
    if (items?.palletDetails?.newConditionType && items?.palletDetails?.newConditionType !== '') palletDetailsString = palletDetailsString + (items?.palletDetails?.newConditionType === 'HARDWOOD' ? ' (HW)' : ' (SW)')
    if (items?.palletDetails?.palletType && items?.palletDetails?.palletType !== '') palletDetailsString = palletDetailsString + ', ' + (items?.palletDetails?.palletType === 'EUROPALLET' ? 'Euro Pallet' : capitalizeFirstLetter(items?.palletDetails?.palletType))
    return <span>{palletDetailsString}</span>
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      backdrop={'static'}
      centered={true}
      fullscreen='fullscreen'
      className={styles.recurranceModal}
    >
      <div className=''>
        <div className={styles.header}>
          <Button handleClick={() => {
            setMultiSelectVal([])
            setIsQtyEditable(false)
            setIsDesiredPriceEditable(false)
            setIsCpuPriceEditable(false)
            setIsDeliveryPriceEditable(false)
            setIsMinPriceEditable(false)
            toggle(!isOpen)
          }}>
            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
          </Button>
          <h3>
            Recurring Posts
            <br />
            <span style={{ "text-transform": "none" }}>Use this screen to edit your recurring post, or delete future recurring posts.</span>
          </h3>

        </div>
        <ModalBody>
          <Formik
            initialValues={getPostInitialValues(items)}
            validationSchema={VALIDATION_SCHEMA()}
            onSubmit={(values) => {
            }}>
            {(props) => {
              const { isValid, dirty, values, errors, touched, setFieldValue } = props;
              return (
                <>
                  <Form>
                    <Container>
                      <Body>
                        <Location>
                          <div className='details-section py-3 section-separator-line'>
                            <div className="row ">
                              <div className="col-md-6 col-sm-12 mb-2 d-flex">
                                <div className="col-50 text-bold label-col-50">
                                  <p>Post Name</p>
                                </div>
                                <div className="col-50 recurring-post-title">
                                  <Tooltip
                                    placement="top"
                                    arrow
                                    title={items?.postName}
                                    enterTouchDelay={0}
                                  >
                                    <p className="titleColour"> {items?.postName}</p>
                                  </Tooltip>
                                </div>
                              </div>

                              <div className="col-md-6 col-sm-12 mb-2 d-flex" style={{ "text-align": "left" }}>
                                <div className="col-50 text-bold label-col-50">
                                  <p>Del Req</p>
                                </div>
                                <div className="col-50">
                                  <p className={styles.pTag} style={{ 'overflow': 'hidden', 'text-overflow': 'ellipsis' }}>
                                    {items?.shippingMode === 'DELIVERY' ? 'Delivery' : 'Pickup'}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6 col-sm-12 mb-2 d-flex">
                                <div className="col-50 text-bold label-col-50">
                                  <p>Pallet Type</p>
                                </div>
                                <div className="col-50 recurring-post-title">

                                  <Tooltip
                                    placement="top"
                                    arrow
                                    title={palletDetailsString(items)}
                                    enterTouchDelay={0}
                                  >
                                    <p style={{ 'overflow': 'hidden', 'text-overflow': 'ellipsis' }}>
                                      {palletDetailsString(items)}
                                    </p>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="col-md-6 col-sm-12 mb-2 d-flex">
                                <div className="col-50 text-bold label-col-50">
                                  <p>{items?.shippingMode !== 'DELIVERY' ? 'Pickup Location' : 'Del Location'}</p>
                                </div>
                                <div className="col-50">
                                  <p className={styles.pTag} style={{ 'display': 'flex' }}>
                                    {items?.shippingAddress?.locationName}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="row">

                              <div className="col-md-6 col-sm-12 mb-2" style={{ 'display': 'flex' }}>
                                <div className="col-50 text-bold label-col-50">
                                  <p>Size</p>
                                </div>
                                <div className="col-50">
                                  <p className={styles.pTag} style={{ 'display': 'flex' }}>
                                    <span> {(items?.palletDetails?.length && items?.palletDetails?.length !== '') ?
                                      <>{`${items?.palletDetails?.length}x${items?.palletDetails?.width}x${items?.palletDetails?.height}`}</>
                                      :
                                      <>{items?.palletDetails?.size}</>
                                    }</span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 col-sm-12 mb-2" style={{ 'display': 'flex' }}>
                                <div className="col-50 text-bold label-col-50">
                                  <p>Address</p>
                                </div>
                                <div className="col-50">
                                  <p className={styles.pTag} style={{ 'display': 'flex' }}>
                                    {items?.shippingAddress?.address1}{items?.shippingAddress?.address2 && <>, {items?.shippingAddress?.address2}</>}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6 col-sm-12 mb-2" style={{ 'display': 'flex' }}>
                                <div className="col-50 text-bold label-col-50">
                                  <p>Grade</p>
                                </div>
                                <div className="col-50">
                                  <p className={styles.pTag} style={{ 'display': 'flex' }}>
                                    {(items?.palletDetails?.grade && items?.palletDetails?.grade !== '') ?
                                      items?.palletDetails?.grade : "NA"}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 col-sm-12 mb-2" style={{ 'display': 'flex' }}>
                                <div className="col-50 text-bold label-col-50">
                                  <p>City, ST, Zip</p>
                                </div>
                                <div className="col-50">
                                  <p className={styles.pTag}>
                                    {items?.shippingAddress?.city.trim()},{" "}{stateConvert(items?.shippingAddress?.state)},{" "}{items?.shippingAddress?.zipCode}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='edit-section py-3 section-separator-line'>
                            <div className='section-title text-center mb-2'>
                              <h3 className='text-bold d-inline' style={{ "font-size": "18px" }}>Edit Recurring Post</h3>
                              <Tooltip
                                placement="top"
                                enterTouchDelay={0}
                                arrow
                                title={
                                  <InfoTitleText style={{ padding: "2px" }}>
                                    Only quantity and price details of your recurring post are editable. Please use the pencil to edit the values and then hit submit for the changes to be posted. If you need to edit any other data points, please delete the recurring post all together and create a new one.
                                  </InfoTitleText>
                                }
                              >
                                <img
                                  style={{
                                    paddingLeft: "5px",
                                    position: "relative",
                                    top: "-1px",
                                  }}
                                  src={information}
                                  alt="information"
                                />
                              </Tooltip>
                            </div>
                            {/* Need */}
                            {(postType === "Need") && <>
                              <div className='row'>
                                <div className="col-md-6 col-sm-12 mb-2">
                                  <div className="col-50 text-bold">
                                    <p>Quantity:</p>
                                  </div>
                                  <div className="col-50">
                                    <NumberInput
                                      name="editRecuurenceQty"
                                      maxLength={4}
                                      showErrorMessages={true}
                                      decimalScale={0}
                                      quantityLotsMaxValue={props.values?.maxEditQty}
                                      disabled={!isQtyEditable}
                                    />
                                    <Button
                                      type="icon-btn"
                                      title="Edit Quantity"
                                      handleClick={() => {
                                        setIsQtyEditable(prevState => !prevState);
                                      }}
                                    >
                                      <img src={Edit} className="icon" alt="Edit" />
                                    </Button>
                                  </div>
                                </div>
                                <div className="col-md-6 col-sm-12 mb-2">
                                  <div className="col-50 text-bold">
                                    <p>
                                      {pageLanguageContents?.Arrow_Price[4]?.Target}
                                      {" "}<small className="pr-2">{pageLanguageContents?.Arrow_Price[5]?.PerPallet}:</small>
                                    </p>
                                  </div>
                                  <div className="col-50">
                                    <NumberInput
                                      name="desiredPrice"
                                      prefix={"$"}
                                      placeholder="$ 0.00"
                                      decimalScale={2}
                                      maxLength={8}
                                      decimalSeparator=","
                                      fixedDecimalScale
                                      thousandSeparator={true}
                                      disabled={!isDesiredPriceEditable}
                                    />
                                    <Button
                                      type="icon-btn"
                                      title="Edit Quantity"
                                      handleClick={() => {
                                        setIsDesiredPriceEditable(prevState => !prevState);
                                      }}
                                    >
                                      <img src={Edit} className="icon" alt="Edit" />
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </>}
                            {/* Inventory */}
                            {
                              (postType === "Inventory") && <>
                                <div className="row">
                                  <div className="col-md-6 col-sm-12 mb-2">
                                    <div className="col-50 text-bold">
                                      <p>Quantity:</p>
                                    </div>
                                    <div className="col-50">
                                      <NumberInput
                                        name="editRecuurenceQty"
                                        maxLength={4}
                                        showErrorMessages={true}
                                        decimalScale={0}
                                        quantityLotsMaxValue={props.values?.maxEditQty}
                                        disabled={!isQtyEditable}
                                      />
                                      <Button
                                        type="icon-btn"
                                        title="Edit Quantity"
                                        handleClick={() => {
                                          setIsQtyEditable(prevState => !prevState);
                                        }}
                                      >
                                        <img src={Edit} className="icon" alt="Edit" />
                                      </Button>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="my-2">
                                      <p className={`mb-0 text-bold ${styles.lineHeight14}`} style={{ minHeight: '20px' }}>
                                        {items?.shippingMode === 'DELIVERY' ? pageLanguageInventoryContents?.Arrow_Price[10]?.MinPrice : pageLanguageInventoryContents?.Arrow_Price[12]?.MinPricePick}
                                        <small className='ml-1'>{pageLanguageInventoryContents?.Arrow_Price[11]?.PerPallet}</small>
                                      </p>
                                    </div>
                                    <div className={styles.field}>
                                      <NumberInput
                                        name="basePrice"
                                        prefix={"$"}
                                        placeholder="$ 0.00"
                                        decimalScale={2}
                                        maxLength={8}
                                        decimalSeparator=","
                                        fixedDecimalScale
                                        thousandSeparator={true}
                                        disabled={!isMinPriceEditable}
                                      />
                                      <Button
                                        type="icon-btn"
                                        title="Edit Quantity"
                                        handleClick={() => {
                                          setIsMinPriceEditable(prevState => !prevState);
                                        }}
                                      >
                                        <img src={Edit} className="icon" alt="Edit" />
                                      </Button>
                                    </div>
                                  </div>
                                  {items?.shippingMode === 'DELIVERY' && (
                                    <div className="col-md-6 col-sm-12">
                                      <div className="my-2">
                                        <p className={`mb-0 text-bold ${styles.lineHeight14}`}>
                                          {pageLanguageInventoryContents?.Arrow_Price[14]?.DeliveryPrice}
                                          <small className='ml-1'>{pageLanguageInventoryContents?.Arrow_Price[11]?.PerPallet}</small>
                                        </p>
                                      </div>
                                      <div className={styles.field}>
                                        <NumberInput
                                          name="buyNowDeliveredPrice"
                                          prefix={"$"}
                                          placeholder="$ 0.00"
                                          decimalScale={2}
                                          maxLength={8}
                                          decimalSeparator=","
                                          fixedDecimalScale
                                          thousandSeparator={true}
                                          disabled={!isDeliveryPriceEditable}
                                        />
                                        <Button
                                          type="icon-btn"
                                          title="Edit Quantity"
                                          handleClick={() => {
                                            setIsDeliveryPriceEditable(prevState => !prevState);
                                          }}
                                        >
                                          <img src={Edit} className="icon" alt="Edit" />
                                        </Button>
                                      </div>
                                    </div>
                                  )}

                                  <div className="col-md-6 col-sm-12">
                                    <div className="my-2">
                                      <p className={`mb-0 text-bold ${styles.lineHeight14}`}>
                                        {pageLanguageInventoryContents?.Arrow_Price[15]?.PickupPrice}
                                        <small className='ml-1'>{pageLanguageInventoryContents?.Arrow_Price[11]?.PerPallet}</small>
                                      </p>
                                    </div>
                                    <div className={styles.field}>
                                      <NumberInput
                                        name="cpuPrice"
                                        prefix={"$"}
                                        placeholder="$ 0.00"
                                        decimalScale={2}
                                        maxLength={8}
                                        decimalSeparator=","
                                        fixedDecimalScale
                                        thousandSeparator={true}
                                        disabled={!isCpuPriceEditable}
                                      />
                                      <Button
                                        type="icon-btn"
                                        title="Edit Quantity"
                                        handleClick={() => {
                                          setIsCpuPriceEditable(prevState => !prevState);
                                        }}
                                      >
                                        <img src={Edit} className="icon" alt="Edit" />
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </>
                            }
                          </div>
                          <div className='delete-section py-3'>
                            <div className='section-title text-center mb-2'>
                              <h3 className='text-bold d-inline' style={{ "font-size": "18px" }}>Delete Future Recurring Posts</h3>
                              <Tooltip
                                placement="top"
                                enterTouchDelay={0}
                                arrow
                                title={
                                  <InfoTitleText style={{ padding: "2px" }}>
                                    Use this section to delete future recurring posts from the scheduler. Select the recurring dates from the dropdown menu, then click on the submit button for the changes to be posted.
                                  </InfoTitleText>
                                }
                              >
                                <img
                                  style={{
                                    paddingLeft: "5px",
                                    position: "relative",
                                    top: "-1px",
                                  }}
                                  src={information}
                                  alt="information"
                                />
                              </Tooltip>
                            </div>
                            <div className="row">
                              <div className="col-12 mb-7" style={{ 'display': 'flex' }}>
                                <div className="col-50 text-bold">
                                  <p>Recurring Post Details:</p>
                                </div>
                                <div className="col-50" style={{ 'width': '75%', 'padding-left': '14px', 'text-align': 'left' }}>
                                  <div className={styles.fieldGroup}>
                                    <p className={styles.pTag}>{recurrenceTag(items?.postRecurrence)}</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 mb-7" style={{ 'display': 'flex' }}>
                                <div className="col-50 text-bold">
                                  <p>Future Recurring Posts:</p>
                                </div>
                                <div className="col-50" style={{ 'width': '50%', 'padding-left': '10px', 'margin-top': '5px' }}>
                                  <div className={styles.fieldGroup}>
                                    <div className="w-100">

                                      <MultiSelectCheckBox
                                        name="postingMethod"
                                        value={multiSelectVal}
                                        options={futureRecDateList}
                                        setMultiSelectVal={setMultiSelectVal}
                                        multiSelectVal={multiSelectVal}
                                        defaultValueArr={multiSelectVal}
                                        multi={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Location>
                      </Body>
                    </Container>
                  </Form >
                  <ActionBtn>
                    <Button
                      type="app-green-button submitBtn"
                      handleClick={() => {
                        setMultiSelectVal([])
                        setIsQtyEditable(false)
                        setIsDesiredPriceEditable(false)
                        setIsCpuPriceEditable(false)
                        setIsDeliveryPriceEditable(false)
                        setIsMinPriceEditable(false)
                        toggle(!isOpen);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="app-green-button"
                      disabled={multiSelectVal?.length === 0 && !dirty}
                      handleClick={async () => {
                        if (actionType === 'EDIT') {
                          submitHandler(props)
                        } else {
                          setOkCancelModalContent(
                            "Are you sure you want to delete this recurring post?"
                          );
                          toggleOkCancelModal()
                        }
                      }}
                    >
                      Submit
                    </Button>
                  </ActionBtn>
                  <YesNoModal
                    isOpen={yesNomodal}
                    toggle={yesNoToggleModal}
                    title=""
                    content={yesNoModalContent}
                    link={modalLink}
                    type={yesNoModalType}
                    onClickHander={(val) => {
                      if ((postType === "Need") && val === "no") {
                        setFieldValue("appointment", "DELIVERY");
                      } else if ((postType === "Inventory") && !val) {
                        yesNoToggleModal();
                        submitHandler(props, true);
                      }
                    }}
                  />
                </>
              );
            }}
          </Formik>
        </ModalBody>

        <OkCancelAlertModal
          isOpen={okCancelModal}
          toggle={toggleOkCancelModal}
          alertType="postDelete"
          content={okCancelModalContent}
          callBackAlert={() => {
            submitHandler();
          }}
        />
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          alertType="editDeleteRecurrence"
          content={modalContent}
          link={modalLink}
          callBackAlert={() => {
            if (loadSuccessState) callBackFun()
          }}
        />
      </div>
    </Modal >
  );
};

const TimeSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  padding: 0;
  background: #fff;
  @media (max-width: 767px) {
    padding-bottom: 0;
    grid-auto-flow: unset;
    gap: 10px;
  }
  h3 {
    font-size: 16px;
    font-family: "latosemibold";
  }
  p {
    font-size: 12px;
    font-family: "latoregular";
    color: #717171;
    margin: 0;
    line-height: 27px;
  }
  & > div {
    display: flex;
    @media (max-width: 767px) {
      display: grid;
      grid-template-columns: 30px 1fr;
      gap: 10px;
      &.flow-column {
        grid-template-columns: 1fr;
        h3 {
          order: 2;
          font-size: 16px;
        }
        p {
          font-size: 16px;
          line-height: 1;
        }
      }
    }
    &.flow-column {
      flex-direction: column;
    }
    .icon-col {
      width: 26px;
      margin-right: 8px;
      &.distance-col {
        max-width: 18px;
      }
      img {
        max-width: 100%;
      }
    }
    .d-text {
      max-width: 190px;
      @media (max-width: 767px) {
        max-width: none;
      }
    }
  }
  @media (max-width: 767px) {
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 13px;
    }
  }
`;